// extracted by mini-css-extract-plugin
export default {"border":"---------packages-corgi-x-src-components-Box-Box-module__border"};